import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { trialBalanceSearchSchema } from '../../features/accounting/search'
import { TrialBalancePage } from '../../features/accounting/trial-balance-page'

export const Route = createFileRoute('/_app/trial-balance')({
  staticData: { crumb: 'trialBalance' },
  validateSearch: trialBalanceSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'reports.financial'),
  component: TrialBalancePage,
})
